import { interpret } from "@xstate/fsm";
import { tracker } from "../../tracker/Tracker";
export function createTrackedInterpreter(machine, userId) {
    const interpreter = interpret(machine);
    const originalStart = interpreter.start;
    interpreter.start = (initialState) => {
        tracker.captureStateMachineTransition({
            machineId: machine.config.id,
            userId,
            newState: initialState ?? machine.config.initial,
        });
        return originalStart(initialState);
    };
    const originalSend = interpreter.send;
    interpreter.send = (event) => {
        const oldState = interpreter.state.value;
        originalSend(event);
        const newState = interpreter.state.value;
        tracker.captureStateMachineTransition({
            machineId: machine.config.id,
            userId,
            oldState,
            event,
            newState,
        });
    };
    return interpreter;
}
//# sourceMappingURL=StateMachineUtils.js.map